import type { ThankYou } from '../../../ThankYous.types'
import type { ThankYouType } from '../SendThankYouModal.types'

export const getThankYouTypeFromData = (thankYou: ThankYou): ThankYouType => {
  const thankYouData = thankYou.thankYous[0]

  if (thankYouData?.mediaType.type === 'video') return 'VIDEO'

  if (thankYouData?.mediaType.type === 'audio') return 'AUDIO'

  if (thankYouData?.mediaType.type === 'image') return 'IMAGE'

  // default
  return 'VIDEO'
}
